import { Modal as MuiModal, Stack, SxProps } from '@mui/material';

import palette from '../theme/palette';

interface ModalProps {
  open: boolean;
  children: React.ReactNode;
  onClose?: (reason?: 'backdropClick' | 'escapeKeyDown') => void;
  sx?: SxProps;
  fullScreen?: boolean;
}

const Modal = ({ open, onClose, children, sx, fullScreen = false }: ModalProps) => {
  return (
    <MuiModal
      open={open}
      onClose={(_, reason) => {
        onClose?.(reason);
      }}
      sx={{
        backdropFilter: 'blur(10px)',
        '&:focus': {
          outline: 'none'
        }
      }}
    >
      <Stack
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: palette.white,
          borderRadius: '16px',
          padding: '16px',
          ...sx,
          ...(fullScreen && {
            top: '0px',
            left: '0px',
            transform: 'unset',
            width: '100vw',
            maxWidth: '100vw',
            maxHeight: '100vh',
            height: '100vh',
            borderRadius: '0px',
            padding: '0px',
            margin: '0px'
          }),
          '&:focus-visible': {
            outline: 'none'
          }
        }}
      >
        {children}
      </Stack>
    </MuiModal>
  );
};

export default Modal;
